import { useEffect, useRef, useState } from "react";
import { animate, useInView } from "framer-motion";
import { FadeIn } from "./Reveal";

function Counter({ to, suffix }) {
    const ref = useRef(null);
    const inView = useInView(ref, { once: true, margin: "-60px" });
    const [val, setVal] = useState(0);

    useEffect(() => {
        if (!inView) return;
        const controls = animate(0, to, {
            duration: 2.2,
            ease: [0.16, 1, 0.3, 1],
            onUpdate: (v) => setVal(Math.round(v)),
        });
        return () => controls.stop();
    }, [inView, to]);

    return (
        <span ref={ref}>
            {val}
            <span className="text-gold">{suffix}</span>
        </span>
    );
}

const STATS = [
    { to: 100, suffix: "+", label: "wykonanych realizacji" },
    { to: 100, suffix: "%", label: "zaangażowania" },
    { to: 24, suffix: "h", label: "szybki kontakt" },
];

export default function Stats() {
    return (
        <section className="border-y border-ink/8 bg-white py-20 md:py-28">
            <div className="mx-auto grid max-w-7xl grid-cols-1 gap-12 px-6 text-center sm:grid-cols-3 md:px-12">
                {STATS.map((s, i) => (
                    <FadeIn key={s.label} delay={i * 0.1}>
                        <div data-testid={`stat-${i}`}>
                            <p className="font-display text-7xl font-black tracking-tighter text-ink md:text-8xl">
                                <Counter to={s.to} suffix={s.suffix} />
                            </p>
                            <p className="mt-3 text-sm font-semibold uppercase tracking-[0.25em] text-ink/45">{s.label}</p>
                        </div>
                    </FadeIn>
                ))}
            </div>
        </section>
    );
}
